<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2">Contents</h2>
<p class="toc"><a href="#/ch01">The Hanging of George Denny</a></p>
<p class="toc"><span href="#/ch02" title="Link target outside of Sample">The Ghosts of Smalley Inn</span></p>
<p class="toc"><span href="#/ch03" title="Link target outside of Sample">Chief Daniel Nimham: Gentleman Warrior</span></p>
<p class="toc"><span href="#/ch04" title="Link target outside of Sample">Sybil Ludington: Spirit of Fire</span></p>
<p class="toc1"><span href="#/acknowledgment" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?c1734538